import MainLayout from '../../components/layouts/MainLayout';

const PostComplete = () => {

  return(
    <MainLayout>
      <div className='post__comp'>
        <h2 className='login__ttl'>投稿が完了しました</h2>
        <div className='post__comp-cont'>
          <span>投稿はMY PAGEよりいつでも編集・削除いただけます。</span>
          <span>募集が終了した際は、投稿の非表示への切り替えを忘れずにお願い致します。</span>
        </div>
        <a href='/sharehouse'>一覧ページへ戻る</a>
        <a href='/mypage'>投稿を確認する</a>
      </div>
    </MainLayout>
  );
};

export default PostComplete;
